export default __webpack_public_path__ + "static/media/progress-2.38b35817.svg";